import { render, staticRenderFns } from "./LogovStage.vue?vue&type=template&id=21d7ab19&"
import script from "./LogovStage.vue?vue&type=script&lang=js&"
export * from "./LogovStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports